import { useEffect } from "react";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";
import MenuLinkBtn from "../../UI/MenuLinkBtn/MenuLinkBtn";

const TestsCategoryPage = () => {
  useEffect(() => {
    document.title = "Работа с тестами";
  }, []);
   
  
  return (
    <section className="settings">
      <div className="container">
        <ButtonBack shortBtn={true} />
        <h1 className="settings__text">Работа с тестами</h1>

        <div className="admin__menu">
          {JSON.parse(localStorage.getItem("user")).admin === 2 && (
            <MenuLinkBtn link="/admin/add-test-category"  text="Добавить категорию"/>
          )}
           <MenuLinkBtn link="/admin/add-test"  text="Добавить вопрос"/>
          
           <MenuLinkBtn link="/admin/check_tests"  text="Все тесты"/>
          
        </div>
      </div>
    </section>
  );
};

export default TestsCategoryPage;
